import {axiosConfigNew as axios} from "../../../utils/axios";

export const apiSchedule = (data: any) => axios.get('/edu/timetable', {
  params: {
    ...(data?.ts ? {ts: data.ts} : {})
  }
})



